import {
  validateOGetReviewItems,
  validateReviewDetailResponse,
} from "@goono-commons/v3/response/review";
import { doAPIDeleteRequest, doAPIGetRequest, doAPIPostRequest } from "./api";
import {
  CreateReviewParams,
  GetReviewListQueryParams,
  RespondToReviewParams,
} from "@goono-commons/v3/request/review";
import { RequestReviewForDraftParams } from "@goono-commons/v3/request/researchDraft";

export const createReview = async (params: {
  token: string;
  workspaceId: string;
  researchNoteId: string;
  body: CreateReviewParams;
}) => {
  await doAPIPostRequest(
    `/projects/${params.researchNoteId}/reviews/${params.workspaceId}`,
    params.token,
    params.body
  );
};

export const createResearchDraftReview = async (params: {
  token: string;
  workspaceId: string;
  researchNoteId: string;
  researchDraftId: string;
  body: RequestReviewForDraftParams;
}) => {
  await doAPIPostRequest(
    `/projects/${params.researchNoteId}/researchDrafts/review/${params.researchDraftId}/${params.workspaceId}`,
    params.token,
    params.body
  );
};

export const getReviewDetailInfo = async (params: {
  token: string;
  workspaceId: string;
  researchNoteId: string;
  reviewId: string;
}) => {
  const ret = await doAPIGetRequest(
    `/reviews/${params.reviewId}/detail/${params.workspaceId}`,
    params.token
  );

  return validateReviewDetailResponse(ret);
};

export const cancelReview = async (params: {
  token: string;
  workspaceId: string;
  researchNoteId: string;
  reviewId: string;
}) => {
  await doAPIDeleteRequest(
    `/projects/${params.researchNoteId}/reviews/${params.reviewId}/${params.workspaceId}`,
    params.token
  );
};

export const respondReview = async (params: {
  token: string;
  workspaceId: string;
  researchNoteId: string;
  reviewId: string;
  body: RespondToReviewParams;
}) => {
  await doAPIPostRequest(
    `/reviews/${params.reviewId}/respond/${params.workspaceId}`,
    params.token,
    params.body
  );
};

export const getRequestedReviewsInResearchNote = async (params: {
  token: string;
  workspaceId: string;
  researchNoteId: string;
  query: GetReviewListQueryParams;
}) => {
  const ret = await doAPIGetRequest(
    `/reviews/requested/project/${params.researchNoteId}/${params.workspaceId}`,
    params.token,
    params.query
  );

  return validateOGetReviewItems(ret);
};

export const getRequestedReviews = async (params: {
  token: string;
  workspaceId: string;
  query: GetReviewListQueryParams;
}) => {
  const ret = await doAPIGetRequest(
    `/reviews/requested/${params.workspaceId}`,
    params.token,
    params.query
  );

  return validateOGetReviewItems(ret);
};

export const getReceivedReviews = async (params: {
  token: string;
  workspaceId: string;
  query: GetReviewListQueryParams;
}) => {
  const ret = await doAPIGetRequest(
    `/reviews/received/${params.workspaceId}`,
    params.token,
    params.query
  );

  return validateOGetReviewItems(ret);
};

export const getOrganizationWorkspaceReviews = async (params: {
  token: string;
  workspaceId: string;
  query: GetReviewListQueryParams;
}) => {
  const ret = await doAPIGetRequest(
    `/organizations/review/list/${params.workspaceId}`,
    params.token,
    params.query
  );

  return validateOGetReviewItems(ret);
};

/** 나중에 필요 시 추가 */
export const updateReviewRespond = () => {
  throw new Error(`not implemented yet`);
};
export const updateReviewComment = () => {
  throw new Error(`not implemented yet`);
};
export const reRequestReview = () => {
  throw new Error(`not implemented yet`);
};
export const addFileToReview = () => {
  throw new Error(`not implemented yet`);
};
export const removeFileFromReview = () => {
  throw new Error(`not implemented yet`);
};
export const replaceReviewFile = () => {
  throw new Error(`not implemented yet`);
};
